export const TAX_NUMBER_REGEX = /^8[0-9]{9}$/;

export const SOCIAL_SECURITY_NUMBER = /^[0-9]{9}$/;

export const GUID_PATTERN = '^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$';

export const HEX_COLOR_PATTERN = '#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$';
